export default __webpack_public_path__ + "static/media/bg6.e1e4752c.jpg";